import { atom } from "recoil";
import { IHomeCompany } from "../types";

export const addStateHomeCompany = atom({
  key: "addStateHomeCompany",
  default: false,
});
export const editStateHomeCompany = atom({
  key: "editStateHomeCompany",
  default: false,
});
export const rowEditHomeCompany = atom<IHomeCompany | undefined>({
  key: "rowEditHomeCompany",
  default: undefined,
});

export const selectedRowsStateHomeCompany = atom<IHomeCompany[]>({
  key: "selectedRowsStateHomeCompany",
  default: [],
});

export const homeCompanyFilterText = atom({
  key: "homeCompanyFilterText",
  default: "",
});

export const homeCompanyFetching = atom({
  key: "homeCompanyFetching",
  default: true,
});
export const homeCompanyReFetching = atom({
  key: "homeCompanyReFetching",
  default: false,
});
